import { render, staticRenderFns } from "./addTemplate.vue?vue&type=template&id=98b39e3a&"
import script from "./addTemplate.vue?vue&type=script&lang=js&"
export * from "./addTemplate.vue?vue&type=script&lang=js&"
import style0 from "./addTemplate.vue?vue&type=style&index=0&id=98b39e3a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports